module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold-slnt=0.ec60b23f.ttf";